import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface InfoCircleIconProps extends SvgProps {
  size?: number;
  strokeWidth?: number;
  color?: keyof AppColors;
}

export const InfoCircleIcon: React.FC<InfoCircleIconProps> = ({
  size = 24,
  strokeWidth = 2,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg {...props} width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Circle
        cx={12}
        cy={12}
        r={10}
        stroke={colors[color]}
        strokeWidth={strokeWidth}
        fill="none"
      />
      <Path
        d="M12 16v-4M12 8h.01"
        stroke={colors[color]}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
